import { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { SeriesData } from '@/types/types';
import { fetchBigQueryData } from '../../../utils/fetchBigQuery';
import { QUERIES } from '../../../constants/queries';
import { getAccessToken } from '../../../utils/authToken';

export function useSeriesData() {
  const [seriesData, setSeriesData] = useState<Record<string, SeriesData[]>>(
    {}
  );
  const { getAccessTokenSilently } = useAuth0();

  const fetchSeriesData = async (rowId: string, studyInstanceUID: string) => {
    try {
      const authToken = await getAccessToken(getAccessTokenSilently);
      const query = QUERIES.SERIES_QUERY(studyInstanceUID);
      const fetchedData = await fetchBigQueryData(authToken, query);
      const processedData = fetchedData.map((item, index) => ({
        id: index + 1,
        ...item,
      }));

      return processedData;
    } catch (error: any) {
      console.error(error);
      throw new Error(error.message || 'Failed to load series data');
    }
  };

  const updateSeriesData = (rowId: string, data: SeriesData[]) => {
    setSeriesData((prev) => ({ ...prev, [rowId]: data }));
  };

  return {
    seriesData,
    fetchSeriesData,
    updateSeriesData,
  };
}
